/// <reference path="../../jquery.d.ts" />

module PoskiQ {
    "use strict";

    export class OrderRecapitulation {
        public static Instance: OrderRecapitulation = null;

        private recapitulation: JQuery;
        private form: JQuery;
        private spinner: JQuery;
        private refreshTimeoutHandle: number;
        private priceFormat: string;

        public constructor() {
            this.recapitulation = this.findContainerIn($(document.body));
            this.form = this.findFormIn($(document.body));
            this.priceFormat = this.recapitulation.data('price-format');
            this.bindRefreshOnFormChange();
            this.refresh();
        }

        private findContainerIn(document: JQuery): JQuery {
            return document.find('.js-order-recapitulation');
        }

        private findFormIn(document: JQuery): JQuery {
            return document.find('form#getCart');
        }

        private addCurrency(priceText: string): string {
            var numberToReplace = (this.priceFormat.indexOf(',0') !== -1) ? '999,00' : '999';
            return this.recapitulation.data('price-format').replace(numberToReplace, priceText);
        }

        private formatPrice(price: number): string {
            var c = (this.priceFormat.indexOf(',0') !== -1) ? 2 : 0;
            var n: any = price, d = ',', t = ' ', s = n < 0 ? "-" : "", i: any = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "", j = (j = i.length) > 3 ? j % 3 : 0;
            var priceText = s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
            return this.addCurrency(priceText);
        }

        private bindRefreshOnFormChange(): void {
            this.form.find('input:radio').on('change', function(/*event: JQueryEventObject*/) {
                this.scheduleRefresh();
            }.bind(this));
        }

        private scheduleRefresh(): void {
            window.clearTimeout(this.refreshTimeoutHandle);
            this.refreshTimeoutHandle = window.setTimeout(this.refresh.bind(this), 1);
        }

        private refresh(): void {
            var total = parseFloat(this.recapitulation.data('itemspricevat'));
            var totalNoVat = parseFloat(this.recapitulation.data('itemsprice'));

            var doPart = function($option: JQuery, $block: JQuery): void {
                var title = '';
                var image = this.recapitulation.data('noimage-url');
                var priceVat = '';
                var price = '';
                if ($option.length > 0) {
                    title = $option.data('title');
                    image = $option.data('image-url');
                    priceVat = $option.data('pricevat-formatted');
                    total += parseFloat($option.data('pricevat'));
                    price = $option.data('price-formatted');
                    totalNoVat += parseFloat($option.data('price'));
                }
                $block.find('.js-title').html(title);
                $block.find('.js-image').find('img').attr('src', image).attr('alt', title).attr('title', title);
                $block.find('.js-image').find('source').attr('srcset', image);
                $block.find('.js-pricevat').html(priceVat);
                $block.find('.js-price').html(price);
                $block.toggle($option.length > 0);
            }.bind(this);

            doPart(this.form.find('input:radio[data-part=delivery]:checked'), this.recapitulation.find('.js-delivery'));
            doPart(this.form.find('input:radio[data-part=payment]:checked'), this.recapitulation.find('.js-payment'));

            this.recapitulation.find('.js-total .js-price-no-vat').html(this.formatPrice(totalNoVat));
            this.recapitulation.find('.js-total .js-pricevat').html(this.formatPrice(total));
        }
    }

    $(function() {
        if (!document.body.className.match(/location_order_getDeliveryAndPayment/))
            return;

        OrderRecapitulation.Instance = new OrderRecapitulation();
    });
}
